import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../base-api.service';
import { City } from '../../model/city';

@Injectable({
  providedIn: 'root'
})
export class CityService extends BaseApiService<City, string> {
  protected endpoint = '/city';

  constructor(protected override http: HttpClient) {
    super(http);
  }
}
